export interface FilterOption<V, M = object> {
  isAvailable?: boolean
  name: string
  value: V
  resultsCount?: number
  metadata: M
  groupInfo?: string
}

export interface SearchPassThroughParams {
  skipCache: string
  debug: string
  isLoadTest: string
  autoLoad: string
  highlightedId: string
  isFlightOnly: string
}

export const searchPassThroughParams = [
  'skipCache',
  'debug',
  'isLoadTest',
  'autoLoad',
  'highlightedId',
  'isFlightOnly',
] as (keyof SearchPassThroughParams)[]
